var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcRouting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.875 13.75H13.75C12.9937 13.75 12.375 13.1313 12.375 12.375C12.375 11.6187 12.9937 11 13.75 11H17.875C17.875 11 22 6.40234 22 4.125C22 1.84766 20.1523 0 17.875 0C15.5977 0 13.75 1.84766 13.75 4.125C13.75 5.2207 14.7039 6.84922 15.6965 8.25H13.75C11.477 8.25 9.625 10.102 9.625 12.375C9.625 14.648 11.477 16.5 13.75 16.5H17.875C18.6313 16.5 19.25 17.1187 19.25 17.875C19.25 18.6313 18.6313 19.25 17.875 19.25H7.9707C7.2832 20.3156 6.51836 21.2996 5.93828 22H17.875C20.148 22 22 20.148 22 17.875C22 15.602 20.148 13.75 17.875 13.75ZM17.875 2.75C18.6355 2.75 19.25 3.36445 19.25 4.125C19.25 4.88555 18.6355 5.5 17.875 5.5C17.1145 5.5 16.5 4.88555 16.5 4.125C16.5 3.36445 17.1145 2.75 17.875 2.75ZM4.125 11C1.84766 11 0 12.8477 0 15.125C0 17.4023 4.125 22 4.125 22C4.125 22 8.25 17.4023 8.25 15.125C8.25 12.8477 6.40234 11 4.125 11ZM4.125 16.5C3.36445 16.5 2.75 15.8855 2.75 15.125C2.75 14.3645 3.36445 13.75 4.125 13.75C4.88555 13.75 5.5 14.3645 5.5 15.125C5.5 15.8855 4.88555 16.5 4.125 16.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRouting);
export default __webpack_public_path__ + "static/media/ic-routing.4d62f9bc028084c01524b698c02c67c6.svg";
export { ForwardRef as ReactComponent };